export default __webpack_public_path__ + "static/media/visible-eye.afdf8405.png";